// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts.css
// module id = 167
// module chunks = 0